import {Links, UserDto} from '../services/generated';
import {CabinetTypicalDto} from '../services/generated/models/CabinetTypicalDto';

export class CabinetTypical implements CabinetTypicalDto {
  public id: number;
  public readonly link: Array<Links> | null;
  public created: string | null;
  public createdBy: UserDto | null;
  public deleted: boolean;
  public modified: string | null;
  public modifiedBy: UserDto | null;
  public version: number;

  public typicalId: string | null;
  public typicalImsId: string | null;
  public nativeTool: string | null;
  public responsibility: string | null;
  public cabinetType: string | null;
  public height: string | null;
  public width: string | null;
  public depth: string | null;
  public plinth: string | null;
  public cableEntry: string | null;
  public cabinetAccess: string | null;
  public cabinetSwingFrame: string | null;
  public equipmentOnDoor: string | null;
  public controlSystem: string | null;
  public system: string | null;
  public numberOfControllers: string | null;
  public cpuRedundancy: string | null;
  public powerInput: string | null;
  public powerSupplyRedundancy: string | null;
  public ioRedundancy: string | null;
  public isIOSignals: string | null;
  public ioSignalsCount: string | null;
  public forExAreasType: string | null;
  public ip: string | null;
  public projectName: string | null;
  public accessToSourcesTitle: string | null;
  public accessToSourcesUrl: string | null;
  public comment: string | null;
  public industry: string | null;
  public manufacturedBy: string | null;
  public approver: string | null;
  public preparedBy: string | null;
  public designeRespPerson: string | null;
  public docStatus: string | null;
  public previewUrl: string | null;
  public url: string | null;



  constructor(cabinetTypical: CabinetTypicalDto) {
    this.id = cabinetTypical.id;
    this.link = cabinetTypical.link;
    this.created = cabinetTypical.created;
    this.createdBy = cabinetTypical.createdBy;
    this.deleted = cabinetTypical.deleted;
    this.modified = cabinetTypical.modified;
    this.modifiedBy = cabinetTypical.modifiedBy;
    this.version = cabinetTypical.version;
    this.typicalId = cabinetTypical.typicalId;
    this.typicalImsId = cabinetTypical.typicalImsId;
    this.nativeTool = cabinetTypical.nativeTool;
    this.responsibility = cabinetTypical.responsibility;
    this.cabinetType = cabinetTypical.cabinetType;
    this.height = cabinetTypical.height;
    this.width = cabinetTypical.width;
    this.depth = cabinetTypical.depth;
    this.plinth = cabinetTypical.plinth;
    this.cableEntry = cabinetTypical.cableEntry;
    this.cabinetAccess = cabinetTypical.cabinetAccess;
    this.cabinetSwingFrame = cabinetTypical.cabinetSwingFrame;
    this.equipmentOnDoor = cabinetTypical.equipmentOnDoor;
    this.controlSystem = cabinetTypical.controlSystem;
    this.system = cabinetTypical.system;
    this.numberOfControllers = cabinetTypical.numberOfControllers;
    this.cpuRedundancy = cabinetTypical.cpuRedundancy;
    this.powerInput = cabinetTypical.powerInput;
    this.powerSupplyRedundancy = cabinetTypical.powerSupplyRedundancy;
    this.ioRedundancy = cabinetTypical.ioRedundancy;
    this.isIOSignals = cabinetTypical.isIOSignals;
    this.ioSignalsCount = cabinetTypical.ioSignalsCount;
    this.forExAreasType = cabinetTypical.forExAreasType;
    this.ip = cabinetTypical.ip;
    this.projectName = cabinetTypical.projectName;
    this.accessToSourcesTitle = cabinetTypical.accessToSourcesTitle;
    this.accessToSourcesUrl = cabinetTypical.accessToSourcesUrl;
    this.comment = cabinetTypical.comment;
    this.industry = cabinetTypical.industry;
    this.manufacturedBy = cabinetTypical.manufacturedBy;
    this.approver = cabinetTypical.approver;
    this.preparedBy = cabinetTypical.preparedBy;
    this.designeRespPerson = cabinetTypical.designeRespPerson;
    this.docStatus = cabinetTypical.docStatus;
    this.previewUrl = cabinetTypical.previewUrl;
    this.url = cabinetTypical.url;


  }}


